import React from 'react';
import PropTypes from 'prop-types';
import { locationShape } from '../../shapes';

import { UniversalContext, Redirect } from '../../../_universal';
import { buildProviderSchedulingUrl } from '../../utils/urls';
import { FLASH_MESSAGES } from '../../constants';

export default class OpeningNotAvailable extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    location: locationShape,
    params: PropTypes.shape({
      providerId: PropTypes.string.isRequired,
    }),
    provider: PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      display: PropTypes.string.isRequired,
      office: PropTypes.shape({
        id: PropTypes.string.isRequired,
        display: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    isOnWidget: PropTypes.bool,
  };

  static contextType = UniversalContext;

  UNSAFE_componentWillMount() {
    const { provider } = this.props;
    this.context.trackEvent({
      onServer: true,
      event: 'Appointment Unavailable',
      properties: {
        providerId: provider.id,
        providerDisplay: provider.display,
        officeId: provider.office.id,
        officeDisplay: provider.office.display,
      },
    });
  }

  render() {
    const { children, location, params, provider, isOnWidget } = this.props;
    const providerId = params ? params.providerId : provider.id;
    const providerUrl = buildProviderSchedulingUrl(providerId, {
      location,
      params: { message: FLASH_MESSAGES.OPENING_NOT_AVAILABLE },
      widget: isOnWidget,
    });
    return (
      <Redirect to={providerUrl} fullNavigation>
        {children}
      </Redirect>
    );
  }
}
